export const LOGIN_COMPLETE = "auth/LOGIN_COMPLETE";
export const LOGOUT = "auth/LOGOUT";
export const LOGOUT_SUCCESS = "auth/LOGOUT_SUCCESS";
export const UPDATE_SUBSCRIPTION = "auth/UPDATE_SUBSCRIPTION";
export const UPDATE_SUBSCRIPTION_SUCCESS = "auth/UPDATE_SUBSCRIPTION_SUCCESS";
export const ACCEPT_TERMS = "auth/ACCEPT_TERMS";
export const ACCEPT_TERMS_SUCCESS = "auth/ACCEPT_TERMS_SUCCESS";